<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/purchase/supplier' }">供应商管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ isEdit ? '编辑供应商' : '新增供应商' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-form :model="forms" :rules="rules" ref="forms" label-width="120px" class="detail-form">
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane label="基本信息" name="basic">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="供应商编号" prop="supplierCode">
                <el-input v-model="forms.supplierCode" autocomplete="off" placeholder="需唯一的编号或简称" :disabled="isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="供应商名称" prop="supplierName">
                <el-input v-model="forms.supplierName" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="供应商类型" prop="supplierType">
                <el-select v-model="forms.supplierType" placeholder="请选择" :disabled="isView">
                  <el-option label="原材料" value="原材料"></el-option>
                  <el-option label="成品" value="成品"></el-option>
                  <el-option label="服务" value="服务"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="联系人" prop="contactName">
                <el-input v-model="forms.contactName" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="联系电话" prop="contactPhone">
                <el-input v-model="forms.contactPhone" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="联系邮箱" prop="contactEmail">
                <el-input v-model="forms.contactEmail" autocomplete="off" type="email" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="联系地址" prop="contactAddress">
                <el-input v-model="forms.contactAddress" autocomplete="off" type="textarea" :rows="2" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="forms.remark" autocomplete="off" type="textarea" :rows="2" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="状态" prop="status">
                <el-radio-group v-model="forms.status" :disabled="isView">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="财务信息" name="finance">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="法人代表" prop="legalPerson">
                <el-input v-model="forms.legalPerson" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="税号" prop="taxNo">
                <el-input v-model="forms.taxNo" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="信用等级" prop="creditLevel">
                <el-select v-model="forms.creditLevel" placeholder="请选择" :disabled="isView">
                  <el-option label="AAA" value="AAA"></el-option>
                  <el-option label="AA" value="AA"></el-option>
                  <el-option label="A" value="A"></el-option>
                  <el-option label="BBB" value="BBB"></el-option>
                  <el-option label="BB" value="BB"></el-option>
                  <el-option label="B" value="B"></el-option>
                  <el-option label="CCC" value="CCC"></el-option>
                  <el-option label="CC" value="CC"></el-option>
                  <el-option label="C" value="C"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="开户银行" prop="bankName">
                <el-input v-model="forms.bankName" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="银行账号" prop="bankAccount">
                <el-input v-model="forms.bankAccount" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="付款条件" prop="paymentTerm">
                <el-input v-model="forms.paymentTerm" autocomplete="off" type="textarea" :rows="3" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="系统信息" name="system" v-if="isEdit">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="创建人">
                <el-input v-model="forms.createUserName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="创建时间">
                <el-input :value="$util.fmtDate(forms.createDate, 'yyyy-MM-dd HH:mm:ss')" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="更新人">
                <el-input v-model="forms.updateUserName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="更新时间">
                <el-input :value="$util.fmtDate(forms.updateDate, 'yyyy-MM-dd HH:mm:ss')" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

      <div class="form-actions">
        <el-button type="primary" icon="Select" @click="submit" v-if="!isView">保存</el-button>
        <el-button icon="Back" @click="goBack">返回</el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
// 使用框架的kaung utility进行API调用

export default {
  name: 'SupplierDetail',
  data() {
    return {
      forms: {
        status: 1,
        supplierType: '原材料'
      },
      rules: {
        supplierCode: [
          { required: true, message: "请输入供应商编号", trigger: "blur" }
        ],
        supplierName: [
          { required: true, message: "请输入供应商名称", trigger: "blur" }
        ],
        supplierType: [
          { required: true, message: "请选择供应商类型", trigger: "change" }
        ],
        contactPhone: [
          { pattern: /^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/, message: "请输入正确的联系电话", trigger: "blur" }
        ],
        contactEmail: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      activeTab: 'basic'
    };
  },
  computed: {
    isEdit() {
      return this.$route.query.id && this.$route.query.mode !== 'view';
    },
    isView() {
      return this.$route.query.mode === 'view';
    },
    supplierId() {
      return this.$route.query.id;
    }
  },
  mounted() {
    if (this.supplierId) {
      this.loadSupplier();
    }
  },
  methods: {
    loadSupplier() {
      let api = this.$kaung.init('PurchaseSupplier');
      api.getone(this.supplierId).then((res) => {
        if (res.code === 200) {
          this.forms = { ...res.data };
        }
      });
    },
    submit() {
      let that = this;
      this.$refs.forms.validate((valid) => {
        if (!valid) return;

        let api = this.$kaung.init('PurchaseSupplier');
        api.submit({
          id: this.forms.id,
          data: this.forms
        }).then((res) => {
          if (res.code === 200) {
            that.$message({
              type: "success",
              message: res.content,
            });
            that.goBack();
          }
        });
      });
    },
    goBack() {
      this.$router.push({ name: 'PurchaseSupplier' });
    }
  }
};
</script>

<style scoped>
.detail-form {
  padding: 20px;
}

.form-actions {
  text-align: center;
  margin-top: 30px;
  padding: 20px 0;
  border-top: 1px solid #e4e7ed;
}

.form-actions .el-button {
  margin: 0 10px;
  min-width: 100px;
}

.el-tabs__content {
  padding: 20px 0;
}
</style>